export const SIGN_RENTER_AGREEMENT = "SIGN_RENTER_AGREEMENT"
export const SIGN_RENTER_AGREEMENT_SUCCESSFUL = "SIGN_RENTER_AGREEMENT_SUCCESSFUL"
export const SIGN_RENTER_AGREEMENT_FAILED = "SIGN_RENTER_AGREEMENT_FAILED"
export const SIGN_RENTER_AGREEMENT_RESET = "SIGN_RENTER_AGREEMENT_RESET"
